import { type GroupedOptionsType } from '@atlaskit/select';

export enum TimeRadioOptions {
	WITHIN_THE_LAST = 'withinTheLast',
	BETWEEN = 'between',
}

export interface DateTimeValue {
	startDate: string;
	endDate: string;
}

export type EventCategoriesGroupType = GroupedOptionsType<{
	label: string;
	value: string;
}>;

export type ByokInformationProps = {
	isByokCustomer: boolean;
	isByokComplianceSettingEnabled: boolean;
};

export type TransitioningExperinceProps = {
	isInTransitioning: boolean;
} & ByokInformationProps;
